export default __webpack_public_path__ + "static/media/left-arrow.8acf1630.svg";